<template>
  <div class="approval-model">
    <el-form class="filter-form" :model="checkData" ref="checkDataRef" label-width="auto">
      <el-form-item :label="$t('平台')" :label-width="$i18n.locale === 'zh-CN' ? '60px' : '90px'">
        <el-select v-model="checkData.platformId" filterable>
          <el-option-group v-for="(group, index) in groupPlatformList" :key="index">
            <el-option v-for="item in group.options" :key="item.id" :disabled="!item.adminHasFlag"
              :label="$i18n.locale === 'zh-CN' ? item.platformName : item.platformNameEn"
              :value="item.platformId"></el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('模板名称')" :label-width="$i18n.locale === 'zh-CN' ? '90px' : '120px'">
        <el-input v-model.trim="checkData.templateName" clearable :placeholder="$t('请输入模板名称')"></el-input>
      </el-form-item>
      <el-form-item style="margin-left: 50px">
        <el-button @click="resetCheckForm">{{ $t('重置') }}</el-button>
        <el-button type="primary" @click="getData">{{ $t('查询') }}</el-button>
      </el-form-item>
    </el-form>
    <el-card v-loading="loadingTableData">
      <div slot="header">
        <div class="operation">
          <el-button type="primary" size="small" icon="el-icon-circle-plus" @click="addPlatPop">{{ $t('新增模板') }}</el-button>
        </div>
      </div>
      <el-table :data="tableData" border align="center" size="mini" style="width: 100%"
        header-row-class-name="self-table-header">
        <el-table-column prop="id" label="ID" width="80px">
        </el-table-column>
        <el-table-column prop="templateCode" :label="$t('模板CODE')" width="200px">
        </el-table-column>
        <el-table-column prop="templateName" :label="$t('模板名称')">
          <template slot-scope="scope">
            {{ $i18n.locale === 'zh-CN' ? scope.row.templateName : scope.row.templateNameEn }}
          </template>
        </el-table-column>
        <el-table-column prop="updateUser" :label="$t('创建人')">
        </el-table-column>
        <el-table-column prop="updateTime" :label="$t('更新时间')" width="160px">
          <template slot-scope="scope">
            {{ formatTime(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('操作')">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain @click="goDetailUrl(scope.row)">{{ $t('流程设计') }}</el-button>
            <el-button type="primary" size="mini" plain @click="editModel(scope.row)">{{ $t('编辑') }}</el-button>
            <el-button type="primary" size="mini" plain @click="deleteModel(scope.row)">{{ $t('删除') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog :title="$t(popTitle)" :visible.sync="dialogDetailVisible" :modal-append-to-body="false"
      :close-on-click-modal="false" @close="cancel">
      <el-form :key="formNum" :model="singleData" :rules="platformFormRules" ref="platFormRef" label-width="auto">
        <el-form-item :label="$t('平台')" prop="platformId">
          <el-select v-model="singleData.platformId" filterable :placeholder="$t('请选择平台')" :disabled="this.editPlatform">
            <el-option-group v-for="(group, index) in groupPlatformList" :key="index">
              <el-option v-for="item in group.options" :key="item.id" :disabled="!item.adminHasFlag"
                :label="$i18n.locale === 'zh-CN' ? item.platformName : item.platformNameEn"
                :value="item.platformId"></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('模板CODE')" prop="templateCode">
          <el-input :disabled="this.editPlatform" v-model="singleData.templateCode" clearable
            :placeholder="$t('请输入模板CODE')">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('中文名称')" prop="templateName">
          <el-input v-model="singleData.templateName" clearable :placeholder="$t('请输入中文名称')">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('英文名称')" prop="templateNameEn">
          <el-input v-model="singleData.templateNameEn" clearable :placeholder="$t('请输入英文名称')">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('中文备注')" prop="templateDesc">
          <el-input v-model="singleData.templateDesc" clearable :placeholder="$t('请输入中文备注')" maxlength="512"
            show-word-limit type="textarea">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('英文备注')" prop="templateDescEn">
          <el-input v-model="singleData.templateDescEn" clearable maxlength="512" show-word-limit type="textarea"
            :placeholder="$t('请输入英文备注')">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancel">{{ $t('取消') }}</el-button>
        <el-button type="primary" @click="savePlat">{{ $t('提交') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Ajax from '@/ajax';
import { formatTime, formatGroupPlatformList } from '@/utils';
import Config from '@/config';
const popTitle = {
  add: '新增模板',
  edit: '更新模板信息'
}

export default {
  data () {
    return {
      formatTime: formatTime,
      Config,
      loadingTableData: false,
      tableData: [],
      groupPlatformList: [],
      dialogDetailVisible: false,
      popTitle: popTitle.add,
      approveModelName: '',
      checkData: {
        platformId: '',
        templateName: ''
      },
      editPlatform: false,
      singleData: {
        platformId: '',
        templateCode: '',
        templateName: '',
        templateNameEn: '',
        templateDesc: '',
        templateDescEn: ''
      },
      formNum: 0
    }
  },
  computed: {
    locale () {
      return this.$i18n.locale;
    },
    platformFormRules () {
      let defaultRules = {
        platformId: [{ required: true, message: this.$t('请选择平台'), trigger: 'change' }],
        templateCode: [
          { required: true, message: this.$t('请输入模板CODE'), trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_-]+$/, message: this.$t('只能输入英文、数字、横线和下划线'), trigger: 'blur' },
          { min: 1, max: 64, message: this.$t('长度不能超过64个字符'), trigger: 'blur' }
        ],
        templateName: [
          { required: true, message: this.$t('请输入中文名称'), trigger: 'blur' },
          { min: 1, max: 128, message: this.$t('长度不能超过128个字符'), trigger: 'blur' }
        ],
        templateNameEn: [
          { min: 1, max: 128, message: this.$t('长度不能超过128个字符'), trigger: 'blur' }
        ]
      };
      return defaultRules;
    }
  },
  created () {
    this.formNum++;
  },
  mounted () {
    this.getPlatformList();
  },
  activated() {
    this.getPlatformList();
  },
  methods: {
    getPlatformList () {
      Ajax({
        url: '/api/platform/list',
        method: 'get'
      })
        .then((res) => {
          this.groupPlatformList = formatGroupPlatformList(res) || [];
          // 找到第一个 platformId
          this.groupPlatformList.forEach(res => {
            (res.options || []).forEach(obj => {
              // 只要第一个且有相关平台权限
              if (!this.checkData.platformId && obj.adminHasFlag)
                this.checkData.platformId = obj.platformId;
            });
          });
          this.getData();
        })
        .catch((err) => {
          this.$message.error(err || this.$t('服务器开小差'));
        })
    },
    getData () {
      if (!this.checkData.platformId) {
        this.$message.warning(this.$t('平台不能为空'));
        return;
      }
      this.loadingTableData = true;
      
      const obj = {
        platformId: this.checkData.platformId
      }
      if (this.$i18n.locale === 'zh-CN') {
        obj.templateName = this.checkData.templateName;
      } else {
        obj.templateNameEn = this.checkData.templateName;
      }
      Ajax({
        url: '/api/approve/biz/template/list',
        method: 'get',
        params: obj
      })
        .then((res) => {
          this.tableData = res.list || [];
          this.loadingTableData = false;
        })
        .catch((err) => {
          this.$message.error(err || this.$t('服务器开小差'));
          console.log(err);
          this.loadingTableData = false;
        });
    },
    deleteModel (obj) {
      this.$confirm(this.$t('确认要删除吗？'), this.$t('注意'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        distinguishCancelAndClose: true,
        type: 'warning'
      })
        .then(() => {
          this.freeze(obj.id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
    },
    freeze (id) {
      Ajax({
        url: '/api/approve/biz/template/delete',
        method: 'get',
        params: {
          id: String(id)
        }
      })
        .then(() => {
          this.$message.success(this.$t('执行成功'));
          this.getData();
          this.dialogDetailVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || this.$t('服务器开小差'));
          console.log(err);
        })
    },
    editModel (obj) {
      this.popTitle = popTitle.edit;
      this.editPlatform = true;
      this.formNum++;
      this.singleData = Object.assign(this.singleData, obj);
      this.dialogDetailVisible = true;
    },
    addPlatPop () {
      this.popTitle = popTitle.add;
      this.editPlatform = false;
      this.formNum++
      this.singleData = {
        platformId: '',
        templateCode: '',
        templateName: '',
        templateNameEn: '',
        templateDesc: '',
        templateDescEn: ''
      }
      this.dialogDetailVisible = true;
    },
    savePlat () {
      this.$refs.platFormRef.validate((valid) => {
        if (valid) {
          let url = '/api/approve/biz/template/create';
          if (this.editPlatform) {
            // approvers返回数据是数组 传给后端需要处理下
            if (Array.isArray(this.singleData.approvers) && this.singleData.approvers.length) {
              this.singleData.approvers = JSON.stringify(this.singleData.approvers);
            } else {
              delete this.singleData.approvers;
            }
            url = '/api/approve/biz/template/update';
          }
          Ajax({
            url: url,
            method: 'post',
            data: this.singleData
          })
            .then(() => {
              this.$message.success(this.$t('执行成功'));
              this.getData();
              this.dialogDetailVisible = false;
            })
            .catch((err) => {
              this.$message.error(err || this.$t('服务器开小差'));
              console.log(err);
            })
        } else {
          return false;
        }
      })
    },
    cancel () {
      this.$refs.platFormRef && this.$refs.platFormRef.resetFields();
      this.dialogDetailVisible = false;
    },
    resetCheckForm () {
      this.checkData.templateName = '';
      this.getData();
    },
    goDetailUrl (obj) {
      const info = {
        data: obj
      };
      this.$router.push({
        path: 'approval_model_detail',
        query: {
          info: btoa(encodeURIComponent(JSON.stringify(info)))
        }
      });
    }
  }
}

</script>

<style scoped lang="scss">
.approval-model {
  .filter-form {
    padding-top: 12px;
    display: flex;
    justify-content: flex-start;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  }
}
</style>
<style lang="scss">
.approval-model {
  .filter-form {
    .el-form-item {
      margin-bottom: 12px;
    }
  }
}
</style>
